import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import useGetSkincareTexturesByProductSlug from 'hooks/useGetSkincareTextureByProductSlug';

import { productsCategories, skincareProducts } from 'constants/products';

import Loading from 'Blocks/Loading';
import TexturesCards from 'Blocks/TexturesCards';

import ErrorContainer from 'Containers/ErrorContainer';

import consultationCategoryProp from 'PropTypes/consultationProps';

import QuestionLayout from '../Scenes/QuestionLayout';

import { getConsultationQuestionForIndex } from 'dux/consultation/selectors';

export const SkincareTextures = ({
  consultationCategory,
  initialValue,
  question,
  questionIndex,
  onNext,
}) => {
  const { subtitle, title, tip, productSlug } = question;
  const { error, fetchTextures, textures, status } = useGetSkincareTexturesByProductSlug({
    productSlug,
    category: productsCategories.SKINCARE,
  });
  const [selectedTexture, setSelectedTexture] = useState();
  const onClickOption = value => {
    setSelectedTexture(value);
  };
  const submit = () => onNext(selectedTexture);

  useEffect(() => {
    setSelectedTexture(Object.values(initialValue)[0]);
  }, [initialValue]);

  if (status === 'error') {
    return (
      <ErrorContainer
        error={error}
        retry={fetchTextures}
        sentryMessage="Invalid state on SkincareTextures"
      />
    );
  }

  return (
    <QuestionLayout
      consultationCategory={consultationCategory}
      disabled={!selectedTexture}
      display="flex"
      justifyContent="start"
      questionIndex={questionIndex}
      submit={submit}
      subtitle={subtitle}
      tipContent={tip}
      title={title}
    >
      {status === 'idle' || status === 'loading' ? (
        <Loading />
      ) : (
        <TexturesCards
          onClickOption={onClickOption}
          selectedTexture={selectedTexture}
          textures={textures}
        />
      )}
    </QuestionLayout>
  );
};

SkincareTextures.propTypes = {
  consultationCategory: consultationCategoryProp.isRequired,
  initialValue: PropTypes.shape({ pref_texture_cleanser: PropTypes.string }),
  question: PropTypes.shape({
    productSlug: PropTypes.oneOf(skincareProducts).isRequired,
    tip: PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
    }),
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }).isRequired,
  questionIndex: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
};

SkincareTextures.defaultProps = {
  initialValue: null,
};

export default connect(
  (state, { consultationCategory, consultationSubsetCategory, questionIndex, routeParams }) => ({
    question: getConsultationQuestionForIndex(state, {
      consultationCategory,
      consultationSubsetCategory,
      questionIndex,
      routeParams,
    }),
  })
)(SkincareTextures);
